import { Koi } from '@ksyos/koi';
import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { IGeneralPractitioner } from '@common/interfaces/generalPractitioner';
import type { Override } from '@common/utils/utilityTypes';
import type { TypedGeneralPractitionerSchema } from '@common/validation/customControls/generalPractitioner';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { generalPractitionerSchema } from '@common/validation/customControls/generalPractitioner';

export type BariPreAddGeneralPractitionerData = {
    generalPractitioner: IGeneralPractitioner;
};

type TypedBariPreAddGeneralPractitionerSchema = Override<
    TypedSchema<BariPreAddGeneralPractitionerData>,
    {
        generalPractitioner: TypedGeneralPractitionerSchema;
    }
>;

export type BariPreAddGeneralPractitionerReadKey = keyof BariPreAddGeneralPractitionerData;
export type BariPreAddGeneralPractitionerReadLabel = 'Huisarts van de patiënt';

export const bariPreAddGeneralPractitionerReadSchema: TypedReadSchema<
    BariPreAddGeneralPractitionerReadKey,
    BariPreAddGeneralPractitionerReadLabel
>[] = [{ items: [{ key: 'generalPractitioner', label: 'Huisarts van de patiënt' }] }];

const bariPreAddGeneralPractitionerFinal: TypedBariPreAddGeneralPractitionerSchema = {
    generalPractitioner: generalPractitionerSchema(),
};

const bariPreAddGeneralPractitionerDraft: TypedBariPreAddGeneralPractitionerSchema = {
    generalPractitioner: generalPractitionerSchema(true),
};

export const bariPreAddGeneralPractitionerDraftSchema = Koi.object(bariPreAddGeneralPractitionerDraft);
export const bariPreAddGeneralPractitionerFinalSchema = Koi.object(bariPreAddGeneralPractitionerFinal);
